/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { checkToken } from 'api/utils';
import { getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getAreas } from 'api/catalogos';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas } from 'api/catalogos/plazas';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const retiroDeAhorrosDetallesPermission = {
  permissionModel: 'descuentodevolucionahorrodetalle',
  catalogsModels: [],
  tabsModels: [],
};

const RetiroDeAhorrosDetallesTable = ({
  permission,
  selectedEmpleados,
  setSelectedEmpleados,
  descuentosEmpleados,
  modalVisible,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [asignacionPlazas, setAsignacionPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);

  const areaBuscar = (value) => {
    const stack = [...areas];
    while (stack.length > 0) {
      const areaNueva = stack.pop();
      if (areaNueva.clave === value?.toString() || areaNueva.value === value?.toString()) {
        return areaNueva;
      }
      if (areaNueva.children) {
        stack.push(...areaNueva.children);
      }
    }
    return null;
  };

  const normalizeData = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const unidad_responsable = normalizeData(clone.unidad_responsable);
        const centro_de_costo = normalizeData(clone.centro_de_costo);
        if (!unidad_responsable.length && !centro_de_costo.length) {
          delete clone.unidad_responsable;
          delete clone.centro_de_costo;
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            tableTitle: clone.descripcion,
            clave: clone.clave,
          });
        }
        if (unidad_responsable) {
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            children: unidad_responsable,
            tableTitle: clone.descripcion,
            clave: clone.clave,
            // disabled: true,
          });
        }
        return ({
          id: clone.id,
          title: `${clone.clave} - ${clone.descripcion}`,
          value: `${clone.clave}/${clone.nivel}`,
          children: centro_de_costo,
          tableTitle: clone.descripcion,
          clave: clone.clave,
          // disabled: true,
        });
      });
      return output;
    }
    return false;
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _puestos,
        _areas,
        _asignacionPlazas,
        _plazas,
      ] = await Promise.all([
        getEmpleadosFiltered(),
        getPuestos(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getAdministracionDePlazas(),
        getPlazas(),
      ]);
      const formattedURS = normalizeData(_areas);
      if (mounted) {
        setEmpleados(_empleados);
        setPuestos(_puestos);
        setAreas(formattedURS);
        setAsignacionPlazas(_asignacionPlazas);
        setPlazas(_plazas);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSelectedRowKeys([]);
  }, [modalVisible]);

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((key) => key !== record.id));
      setSelectedEmpleados(selectedEmpleados.filter((emp) => emp?.descuento_empleado !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
      setSelectedEmpleados([...selectedEmpleados, { empleado: record?.empleado, descuento_empleado: record?.id }]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleSelectAll = (selected, selectedRows, changeRows) => {
    setSelectedRowKeys(selectedRows.map((row) => row.id));
    // eslint-disable-next-line arrow-body-style
    setSelectedEmpleados(selectedRows.map((row) => {
      return {
        empleado: row?.empleado,
        descuento_empleado: row.id,
      };
    }));
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const columns = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'noNombreEmpleado',
      key: 'noNombreEmpleado',
      width: 300,
      render: (val) => {
        const empleado = empleados.find((emp) => emp?.id === val);
        return `${empleado?.numero_de_empleado} - ${empleado?.nombre} ${empleado?.apellido_materno || ''} ${empleado?.apellido_paterno || ''}`;
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puestoTabla',
      key: 'puestoTabla',
      width: 300,
      render: (val) => {
        const asignacionPlaza = asignacionPlazas?.find((asigPlaza) => asigPlaza?.empleado === val);
        const plaza = plazas?.find((pl) => pl?.id === asignacionPlaza?.plaza);
        const puestoEmp = puestos?.find((puesto) => plaza?.puesto === puesto?.id)?.descripcion;
        return `${puestoEmp || ''}`;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'areaTabla',
      key: 'areaTabla',
      width: 300,
      render: (val) => {
        const asignacionPlaza = asignacionPlazas?.find((asigPlaza) => asigPlaza?.empleado === val);
        const plaza = plazas?.find((pl) => pl?.id === asignacionPlaza?.plaza);
        const areaEmp = areaBuscar(plaza?.area_content_id)?.tableTitle;
        return `${areaEmp || ''}`;
      },
    },
    {
      titleText: 'Importe Acumulado',
      dataIndex: 'importe_acumulado_tabla',
      key: 'importe_acumulado_tabla',
      width: 300,
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={descuentosEmpleados}
          allowSearch
          cols={columns}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
        />
      </Spin>
    </Row>
  );
};

export default RetiroDeAhorrosDetallesTable;
